/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserGroupAssignmentCreate
 */
export interface UserGroupAssignmentCreate {
    /**
     * 
     * @type {string}
     * @memberof UserGroupAssignmentCreate
     */
    userGroupId: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupAssignmentCreate
     */
    userId: string;
}

/**
 * Check if a given object implements the UserGroupAssignmentCreate interface.
 */
export function instanceOfUserGroupAssignmentCreate(value: object): value is UserGroupAssignmentCreate {
    if (!('userGroupId' in value) || value['userGroupId'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    return true;
}

export function UserGroupAssignmentCreateFromJSON(json: any): UserGroupAssignmentCreate {
    return UserGroupAssignmentCreateFromJSONTyped(json, false);
}

export function UserGroupAssignmentCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserGroupAssignmentCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'userGroupId': json['userGroupId'],
        'userId': json['userId'],
    };
}

export function UserGroupAssignmentCreateToJSON(json: any): UserGroupAssignmentCreate {
    return UserGroupAssignmentCreateToJSONTyped(json, false);
}

export function UserGroupAssignmentCreateToJSONTyped(value?: UserGroupAssignmentCreate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userGroupId': value['userGroupId'],
        'userId': value['userId'],
    };
}

